const KboDate = Date
KboDate.prototype.getDayOfWeekKor = function () {
  return this.weekList[this.getDay()]
}
KboDate.prototype.getMonthDate = function () {
  return `${this.getMonth() + 1}/${this.getDate()}`
}
KboDate.prototype.getYearMonth = function () {
  const month = this.getMonth() + 1
  return `${this.getFullYear()}${month < 10 ? '0' + month : month}`
}
KboDate.prototype.getYearMonthDate = function () {
  const date = this.getDate()
  return `${this.getYearMonth()}${date < 10 ? '0' + date : date}`
}
KboDate.prototype.clone = function () {
  return new KboDate(this.getFullYear(), this.getMonth(), this.getDate())
}
KboDate.prototype.setQueryDate = function (yearMonthDateString) {
  const year = yearMonthDateString.substring(0, 4)
  const month = yearMonthDateString.substring(4, 6)
  const date = yearMonthDateString.substring(6, 8)
  this.setFullYear(year)
  this.setMonth(Number(month) - 1)
  this.setDate(date)
}
KboDate.prototype.weekList = ['일', '월', '화', '수', '목', '금', '토']
KboDate.prototype.toObject = function () {
  return {
    year: this.getFullYear(),
    month: this.getMonth(),
    date: this.getDate(),
    weekday: this.weekList[this.getDay()]
  }
}
// class KboDate extends Date {
//   getDayOfWeekKor () {
//     return this.weekList[this.getDay()]
//   }
//   getMonthDate () {
//     return `${this.getMonth() + 1}/${this.getDate()}`
//   }
//   getYearMonth () {
//     const month = this.getMonth() + 1
//     return `${this.getFullYear()}${month < 10 ? '0' + month : month}`
//   }
//   getYearMonthDate () {
//     const date = this.getDate()
//     return `${this.getYearMonth()}${date < 10 ? '0' + date : date}`
//   }
//   clone () {
//     return new KboDate(this.getFullYear(), this.getMonth(), this.getDate())
//   }
//   setQueryDate (yearMonthDateString) {
//     const year = yearMonthDateString.substring(0, 4)
//     const month = yearMonthDateString.substring(4, 6)
//     const date = yearMonthDateString.substring(6, 8)
//     this.setFullYear(year)
//     this.setMonth(Number(month) - 1)
//     this.setDate(date)
//   }
//   get weekList () {
//     return ['일', '월', '화', '수', '목', '금', '토']
//   }
//   toObject () {
//     return {
//             year: this.getFullYear(),
//             month: this.getMonth(),
//             date: this.getDate(),
//             weekday: this.weekList[this.getDay()]
//           }
//   }
// }
export default KboDate
